import type { AppLocale } from "./model/locale"
import { createI18n } from "vue-i18n"
import en from "./locales/en.json"
import ru from "./locales/ru.json"
import uz from "./locales/uz.json"
import { FALLBACK_LOCALE, INTL_LOCALES, resolveInitialLocale, storeLocale } from "./model/locale"

export type { AppLocale }
export {
  DEFAULT_LOCALE,
  INTL_LOCALES,
  isAppLocale,
  SUPPORTED_LOCALES,
} from "./model/locale"

export { naiveLocales } from "./model/naive-locale"

export const messages = { uz, ru, en }

// The instance lives in `shared` rather than `app/providers` so non-component
// code (formatters, API error mapping) can translate without importing upwards.
export const i18n = createI18n({
  legacy: false,
  locale: resolveInitialLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  messages,
})

/**
 * Translate outside a component — same catalogue, no `useI18n()` scope needed.
 * Wrapped rather than re-exported so the signature stays nameable in .d.ts output.
 */
export function t(key: string, named: Record<string, unknown> = {}): string {
  return i18n.global.t(key, named)
}

export function currentLocale(): AppLocale {
  return i18n.global.locale.value as AppLocale
}

/** The BCP 47 tag for `Intl` formatters that follow the UI language. */
export function currentIntlLocale(): string {
  return INTL_LOCALES[currentLocale()]
}

export function setAppLocale(locale: AppLocale): void {
  i18n.global.locale.value = locale
  storeLocale(locale)
  applyDocumentLocale()
}

/** Mirrors the active locale onto `<html lang>`. Called once at startup. */
export function applyDocumentLocale(): void {
  document.documentElement.setAttribute("lang", currentLocale())
}
